// extracted by mini-css-extract-plugin
module.exports = {"main":"Table2_main__txiEn","headertxt":"Table2_headertxt__2jZ9l","list":"Table2_list__1JmT9","firstItemBold":"Table2_firstItemBold__1AxWS","link":"Table2_link__1puRb"};